import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const ErrorIcon: FC<IconProps> = ({
  width = 16,
  height = 16,
  fillColor = IconColor.LOSE,
  ...props
}) => {
  return (
    <svg
      fill="none"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.66671 9.16671H11.3334V7.83337H4.66671V9.16671ZM8.00004 15.1667C7.07782 15.1667 6.21115 14.9917 5.40004 14.6417C4.58893 14.2917 3.88337 13.8167 3.28337 13.2167C2.68337 12.6167 2.20837 11.9112 1.85837 11.1C1.50837 10.2889 1.33337 9.42226 1.33337 8.50004C1.33337 7.57782 1.50837 6.71115 1.85837 5.90004C2.20837 5.08893 2.68337 4.38337 3.28337 3.78337C3.88337 3.18337 4.58893 2.70837 5.40004 2.35837C6.21115 2.00837 7.07782 1.83337 8.00004 1.83337C8.92226 1.83337 9.78893 2.00837 10.6 2.35837C11.4112 2.70837 12.1167 3.18337 12.7167 3.78337C13.3167 4.38337 13.7917 5.08893 14.1417 5.90004C14.4917 6.71115 14.6667 7.57782 14.6667 8.50004C14.6667 9.42226 14.4917 10.2889 14.1417 11.1C13.7917 11.9112 13.3167 12.6167 12.7167 13.2167C12.1167 13.8167 11.4112 14.2917 10.6 14.6417C9.78893 14.9917 8.92226 15.1667 8.00004 15.1667Z"
        fill={fillColor}
      />
    </svg>
  );
};
